// src/ErrorBoundary.js

import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      err: null,
      info: null,
    };
  }

  static getDerivedStateFromError(err) {
    return {
      err,
    };
  }

  componentDidCatch(err, info) {
    console.error('💥 UI crash:', err);
    console.error('💥 Component stack:', info?.componentStack);

    this.setState({
      info,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { err, info } = this.state;

    if (err) {
      const errorName =
        err?.name ||
        'UnknownError';

      const errorMessage =
        err?.message ||
        String(err);

      const errorStack =
        err?.stack ||
        'No JavaScript stack available.';

      const componentStack =
        info?.componentStack ||
        'No React component stack available.';

      return (
        <div
          style={{
            minHeight: '100vh',
            padding: '18px',
            boxSizing: 'border-box',
            background: '#111111',
            color: '#ffffff',
            fontFamily: 'system-ui, sans-serif',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <h2
            style={{
              margin: '0 0 14px',
              fontSize: '20px',
            }}
          >
            BarterFi crash report
          </h2>

          <div
            style={{
              marginBottom: '14px',
              padding: '12px',
              borderRadius: '10px',
              background: '#241414',
              border: '1px solid #7a2d2d',
            }}
          >
            <div
              style={{
                marginBottom: '6px',
                fontSize: '13px',
                fontWeight: '700',
                color: '#ff8d8d',
              }}
            >
              Error name
            </div>

            <div
              style={{
                fontSize: '14px',
                overflowWrap: 'anywhere',
              }}
            >
              {errorName}
            </div>
          </div>

          <div
            style={{
              marginBottom: '14px',
              padding: '12px',
              borderRadius: '10px',
              background: '#181818',
              border: '1px solid #444444',
            }}
          >
            <div
              style={{
                marginBottom: '6px',
                fontSize: '13px',
                fontWeight: '700',
              }}
            >
              Error message
            </div>

            <div
              style={{
                fontSize: '13px',
                lineHeight: '1.45',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere',
              }}
            >
              {errorMessage}
            </div>
          </div>

          <details
            open
            style={{
              marginBottom: '14px',
              padding: '12px',
              borderRadius: '10px',
              background: '#181818',
              border: '1px solid #444444',
            }}
          >
            <summary
              style={{
                cursor: 'pointer',
                fontWeight: '700',
                fontSize: '13px',
              }}
            >
              React component stack
            </summary>

            <pre
              style={{
                marginTop: '10px',
                marginBottom: 0,
                fontSize: '11px',
                lineHeight: '1.45',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere',
              }}
            >
              {componentStack}
            </pre>
          </details>

          <details
            style={{
              marginBottom: '16px',
              padding: '12px',
              borderRadius: '10px',
              background: '#181818',
              border: '1px solid #444444',
            }}
          >
            <summary
              style={{
                cursor: 'pointer',
                fontWeight: '700',
                fontSize: '13px',
              }}
            >
              JavaScript stack
            </summary>

            <pre
              style={{
                marginTop: '10px',
                marginBottom: 0,
                fontSize: '11px',
                lineHeight: '1.45',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere',
              }}
            >
              {errorStack}
            </pre>
          </details>

          <button
            type="button"
            onClick={this.handleReload}
            style={{
              width: '100%',
              minHeight: '44px',
              border: 'none',
              borderRadius: '10px',
              background: '#2ecc71',
              color: '#ffffff',
              fontSize: '15px',
              fontWeight: '700',
              cursor: 'pointer',
            }}
          >
            Reload BarterFi
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
